<template>
<div class="chapter">
<div class="inner_page">
<p class="C671"><strong><a id="page_25">II</a></strong></p><a id="page_25">
<p class="C662"><em>Geographic, Historical, and Literary Orientations (1882–1962)</em></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 12_TWO__Geographic__Historical__and.vue?3ea67852